<script setup lang="ts">
import { StatsigSingleton } from '@laam/statsig-client';
import Statsig, { type StatsigUser } from 'statsig-node';
import {
	brandListingExperimentInjectionKey,
	isDeliveryDaysExperimentInjectionKey,
	PDPRedesignExperimentInjectionKey,
	PlpVideoIconExperimentInjectionKey,
	type PDPRedesignExperiment,
	type BrandListingExperiment,
	type PlpVideoIconExperiment,
} from '~/utils/use-statsig-experiment';

const pdpRedesignExperiment = useState<PDPRedesignExperiment | undefined>(
	'pdpRedesign',
	() => undefined,
);

const globalCutoffConfig = ref();
const deliveryDaysExperiment = ref<boolean>(false);
const brandsListingExperiment = ref<BrandListingExperiment>({
	variant: 'control',
});
const plpVideoIconExperiment = ref<PlpVideoIconExperiment>();

onServerPrefetch(async () => {
	const stableId = useCookie('statsig-stable-id');
	const user: StatsigUser = {
		customIDs: {
			stableID: stableId.value!,
		},
	};
	if (stableId.value) {
		pdpRedesignExperiment.value = Statsig.getExperiment(user, 'pdp-redesign-v2')
			.value as PDPRedesignExperiment;
	}
});

onMounted(async () => {
	globalCutoffConfig.value = StatsigSingleton.getDynamicConfig(
		'shipping-cutoff-config',
	).value;
	deliveryDaysExperiment.value = StatsigSingleton.getExperiment(
		'delivery-days',
	).get('Allowed', false);

	brandsListingExperiment.value.variant = StatsigSingleton.getExperiment(
		'brands_listing_page',
	).get('variant', 'control') as BrandListingExperiment['variant'];
	plpVideoIconExperiment.value = StatsigSingleton.getExperiment(
		'plp-video-icon',
	).value as PlpVideoIconExperiment;
});

provide(PDPRedesignExperimentInjectionKey, pdpRedesignExperiment);

provide('globalCutoffConfig', globalCutoffConfig);
provide(isDeliveryDaysExperimentInjectionKey, deliveryDaysExperiment);
provide(brandListingExperimentInjectionKey, brandsListingExperiment);
provide(PlpVideoIconExperimentInjectionKey, plpVideoIconExperiment);
</script>
<template>
	<slot />
</template>
